import Swal from "sweetalert2";
import {i18n} from "../i18n";

export default function useModal() {
    const {
        t
    } = i18n.global

    function getModalConfig({title, text, type, confirmText}) {
        return {
            title: title,
            text: text,
            icon: type,
            showCancelButton: true,
            confirmButtonText: confirmText,
            cancelButtonText: t('Close'),
            customClass: {
                confirmButton: 'secondary-btn',
                cancelButton: 'primary-btn ml-1',
            },
            buttonsStyling: false,
        }
    }

    function openModal(config, callback) {
        Swal.fire(config).then((result) => {
            if (result.value) {
                callback(result)
            }
        })
    }

    function deleteFileModal(callback) {
        const config = getModalConfig({
            title: t('remove_file_title'),
            text: t('remove_file_text'),
            type: 'warning',
            confirmText: t('remove_confirm'),
        })

        openModal(config, callback)
    }

    function deleteProductModal(callback) {
        const config = getModalConfig({
            title: t('remove_product_title'),
            text: t('remove_product_text'),
            type: 'warning',
            confirmText: t('remove_confirm'),
        })

        openModal(config, callback)
    }

    return {
        deleteProductModal,
        deleteFileModal,
        getModalConfig
    }
}
